import React from 'react';
import { Link } from 'react-router-dom';
import { ContentTitle } from '../../../../components/utilities/styledComponents/ContentTitle';
import FormAdsTemplate from '../../../../components/FormAdsTemplate';
import { Container } from '../Creation/style';

const getId = props => props.match.params.relatorioId;

const Edit = props => (
	<Container>
		<ContentTitle className="d-flex justify-content-between">
			<div>
				<h1>Template de anúncio</h1>
			</div>
		</ContentTitle>

		<nav>
			<Link to="/backoffice/templates" className="link-back">
				{'< Voltar para listagem'}
			</Link>
		</nav>

		<section className="box">
			<div className="d-flex align-items-center">
				<i className="fas fa-columns" />
				<h2>Edição de template</h2>
			</div>
			<FormAdsTemplate
				messageSuccess="Template de anúncio atualizado com sucesso."
				id={getId(props)}
				btnText="Atualizar template"
			/>
		</section>
	</Container>
	);

export default Edit;
